import { defineMessages, useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { IconMapPinFilled } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { Location } from "@shared/graphql";
import { SkeletonableProps, WithTitle } from "../../tools/components";
import MapBlocker from "../common/map-blocker";
import { MapMarker } from "../../bundles/map";
import SpriteIcon from "../medias/sprite-icon";
import "./location.scss";

const transDefs = defineMessages({
  label: { id: "article.map-label", defaultMessage: "Vous pouvez consulter l'emplacement de ce bien ici." }
});

type Props = {
  address: Location;
  coordinates?: [ number, number ];
}
const LocationPart = ({ className, loading, title, data }: WithTitle<SkeletonableProps<Props>>) => {

  const intl = useIntl();
  const wrapperClasses = classNames("location-part", className);

  if (loading || !data)
    return (
      <div className={wrapperClasses}>
        <h2><Skeleton width="33%" /></h2>
        <Skeleton className="address" width="20%" />
        <Skeleton className="mapped" inline={true} />
      </div>);

  return (
    <div className={wrapperClasses}>
      <h2>{title}</h2>
      <span className="address">
        <SpriteIcon hash="contact.pin-location" />
        {data.address.resume}
      </span>
      {!!data.coordinates &&
        <MapBlocker className="mapped"
                    center={data.coordinates}
                    label={intl.formatMessage(transDefs.label)}>
          <MapMarker position={data.coordinates}
                     icon={<div className="article-marker"><IconMapPinFilled size="2.5rem" /></div>} />
        </MapBlocker>
      }
    </div>);

}

export default LocationPart;
